import Step from './step';
import QuickNav from './quickNav';
import QuickTypeNav from './quickTypeNav';
export default {
  Step,
  QuickNav,
  QuickTypeNav
};
